import { INITIALIZE_AUTH } from 'FormsUI/actions/ActionTypes';
const initialState = {};
export const auth = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_AUTH:
      return {
        user: action.user,
        gates: action.gates,
        portal: action.portal
      };
    default:
      return state;
  }
};